import React from "react";
import "@/App.css";
import { BookDemoProvider } from "@/contexts/BookDemoContext";
import BookDemoModal from "@/components/landing/BookDemoModal";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustedBy from "@/components/landing/TrustedBy";
import Problem from "@/components/landing/Problem";
import Industries from "@/components/landing/Industries";
import Scrollytelling from "@/components/landing/Scrollytelling";
import RolePlay from "@/components/landing/RolePlay";
import Benefits from "@/components/landing/Benefits";
import Analytics from "@/components/landing/Analytics";
import UseCases from "@/components/landing/UseCases";
import Impact from "@/components/landing/Impact";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";

export default function App() {
  return (
    <BookDemoProvider>
      <div className="App bg-white text-slate-900 antialiased">
        <Navbar />
        <main>
          <Hero />
          <TrustedBy />
          <Problem />
          <Industries />
          <Scrollytelling />
          <RolePlay />
          <Benefits />
          <Analytics />
          <UseCases />
          <Impact />
          <FAQ />
          <FinalCTA />
        </main>
        <BookDemoModal />
      </div>
    </BookDemoProvider>
  );
}
